// extracted by mini-css-extract-plugin
export default {"home__categories":"HomePage_home__categories__DMV7k"};